<template>
  <el-container class="data-detail-wrip customer-detail-wrip">
    <header>
      <i class="iconfont icon-nav-platform"></i>
      {{customerDetail.company_name}}
      <i class="iconfont icon-close" @click="closeDialog"></i>
    </header>
    <div class="tab-box">
      <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>客户资料</span></div>
      <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>功能清单</span></div>
      <div class="tab-item" :class="(tabType == 2)?'active':''" @click="dtlChange(2)" v-if="moduleIds.includes(3)"><span>增购</span></div>
      <div class="tab-item" :class="(tabType == 3)?'active':''" @click="dtlChange(3)" v-if="moduleIds.includes(4)"><span>减购</span></div>
      <div class="tab-item" :class="(tabType == 4)?'active':''" @click="dtlChange(4)" v-if="moduleIds.includes(5)"><span>续费</span></div>
      <div class="tab-item" :class="(tabType == 7)?'active':''" @click="dtlChange(7)" v-if="moduleIds.includes(21)"><span>续费订单</span></div>
      <div class="tab-item" :class="(tabType == 5)?'active':''" @click="dtlChange(5)"><span>本地监测</span></div>
      <div class="tab-item" :class="(tabType == 8)?'active':''" @click="dtlChange(8)" v-if="moduleIds.includes(22)"><span>运营管理</span></div>
      <div class="tab-item" :class="(tabType == 6)?'active':''" @click="dtlChange(6)"><span>操作记录</span></div>
    </div>
    <div class="head" v-if="tabType == 0">
      <span>基本信息</span>
      <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(12) || funAuth.includes(13) || funAuth.includes(14)">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1" v-if="funAuth.includes(13)">转移负责人</el-dropdown-item>
          <el-dropdown-item command="2" v-if="customerDetail.status == 1 && funAuth.includes(14)">启  用</el-dropdown-item>
          <el-dropdown-item command="2" v-if="customerDetail.status == 0 && funAuth.includes(14)">停  用</el-dropdown-item>
          <el-dropdown-item command="3" v-if="funAuth.includes(12) && customerDetail.status == 1">删  除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="editCustomer" v-if="funAuth.includes(11)">编 辑</el-button>
    </div>
    <div class="head" v-if="tabType == 1">
      <span>功能清单</span>
      <el-button type="primary" @click="editfeature" v-if="funAuth.includes(11)">编 辑</el-button>
    </div>
    <div class="head" v-if="tabType == 2">
      <span>增购</span>
      <el-button type="primary" @click="additionalDialog" v-if="funAuth2.includes(15)">增 购</el-button>
    </div>
    <div class="head" v-if="tabType == 3">
      <span>减购</span>
      <el-button type="primary" @click="reductionDialog" v-if="funAuth2.includes(46)">减 购</el-button>
    </div>
    <div class="head" v-if="tabType == 4">
      <span>续费</span>
      <el-button type="primary" @click="renewalDialog" v-if="funAuth2.includes(18)">续 费</el-button>
    </div>
    <div class="head" v-if="tabType == 5"><span>本地监测</span></div>
    <div class="head" v-if="tabType == 6"><span>操作记录</span></div>
    <div class="head" v-if="tabType == 7"><span>续费订单</span></div>
    <div class="head" v-if="tabType == 8">
      <span>运营管理</span>
      <el-input class="seach" size="small" v-model="searchInput" placeholder="功能名称" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
      <el-date-picker v-model="dataTime" size="small" type="date" placeholder="选择日期" value-format="timestamp" @change="queryDataembeddingpointList"></el-date-picker>
    </div>
    <div class="content">
      <el-collapse v-model="activeNames" v-if="tabType == 0">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="iconfont icon-zhankai"></i>
            基本信息
          </template>
          <div class="form">
            <div class="item">
              <span class="title">客户编号</span>
              <div class="item-content">{{customerDetail.company_no}}</div>
            </div>
            <div class="item">
              <span class="title">客户名称</span>
              <div class="item-content">{{customerDetail.company_name}}</div>
            </div>
            <div class="item">
              <span class="title">客户姓名</span>
              <div class="item-content">{{customerDetail.user_name}}</div>
            </div>
            <div class="item">
              <span class="title">联系电话</span>
              <div class="item-content">{{customerDetail.phone}}</div>
            </div>
            <div class="item">
              <span class="title">部署方式</span>
              <div class="item-content">{{(customerDetail.deployment_type === '1') ? '本地初始化':'云服务初始化'}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '1'">
              <span class="title">域名地址</span>
              <div class="item-content">{{customerDetail.local_domain_address}}</div>
            </div>
            <!-- <div class="item" :class="{'single': customerDetail.database_url}" v-if="customerDetail.deployment_type === '1'">
              <span class="title">数据库地址</span>
              <div class="item-content">{{customerDetail.database_url}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '1'">
              <span class="title">数据库用户名</span>
              <div class="item-content">{{customerDetail.database_username}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '1'">
              <span class="title">数据库密码</span>
              <div class="item-content">{{customerDetail.database_passwd}}</div>
            </div> -->
            <div class="item">
              <span class="title">开通版本</span>
              <div class="item-content" v-text="editionInit(customerDetail.edition)"></div>
            </div>
            <div class="item">
              <span class="title">组件版本</span>
              <div class="item-content">{{customerDetail.cm_name}}</div>
            </div>
            <div class="item">
              <span class="title">开通坐席</span>
              <div class="item-content">{{customerDetail.allow_number}}</div>
            </div>
            <div class="item">
              <span class="title">套餐开始日期</span>
              <div class="item-content">{{customerDetail.start_time | formatDate('yyyy-MM-dd')}}</div>
            </div>
            <div class="item">
              <span class="title">套餐结束日期</span>
              <div class="item-content">{{customerDetail.end_time | formatDate('yyyy-MM-dd')}}</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '0'">
              <span class="title">附件空间</span>
              <div class="item-content">{{customerDetail.attachment_size}}GB</div>
            </div>
            <div class="item" v-if="customerDetail.deployment_type === '0'">
              <span class="title">总数据量</span>
              <div class="item-content">{{customerDetail.data_size}}条</div>
            </div>
            <div class="item">
              <span class="title">内部帐户</span>
              <div class="item-content">{{customerDetail.internal_account==1?'否':'是'}}</div>
            </div>
            <div class="item">
              <span class="title">坐席单价(个)</span>
              <div class="item-content">{{customerDetail.seat_unit_price}} {{customerDetail.deployment_type==1?'元':'元/年'}}</div>
            </div>
            <div class="item">
              <span class="title">邀请码</span>
              <div class="item-content">{{customerDetail.invite_code}}</div>
            </div>
            <div class="item">
              <span class="title">维护客服</span>
              <div class="item-content">{{customerDetail.customer_name}}</div>
            </div>
            <div class="item">
              <span class="title">客户状态</span>
              <div class="item-content">{{(customerDetail.status == 0 ? '启用':'停用')}}</div>
            </div>
            <div class="item single">
              <span class="title">备注</span>
              <div class="item-content">{{customerDetail.remark}}</div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <i class="iconfont icon-zhankai"></i>
            系统信息
          </template>
          <div class="form">
            <div class="item">
              <span class="title">创建人</span>
              <div class="item-content">{{customerDetail.create_by}}</div>
            </div>
            <div class="item">
              <span class="title">创建时间</span>
              <div class="item-content">{{customerDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
            <div class="item">
              <span class="title">修改人</span>
              <div class="item-content">{{customerDetail.modify_by}}</div>
            </div>
            <div class="item">
              <span class="title">修改时间</span>
              <div class="item-content">{{customerDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <feature-list v-if="tabType == 1" :featureData="featureData"></feature-list>

      <el-table class="el-table-02" :data='tableList' style='width: 100%' @row-click="additionalRow" key='Table2' v-if="tabType == 2">
        <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
        <el-table-column prop='user_name' label='客户姓名' min-width='140'></el-table-column>
        <el-table-column prop='phone' label='联系电话' min-width='140'></el-table-column>
        <el-table-column label='增购项目' min-width='140'>
          <template slot-scope='scope'>
            <span v-text="afieldInit(scope.row.type)"></span>
          </template>
        </el-table-column>
        <el-table-column prop='create_by' label='创建人' min-width='100'></el-table-column>
        <el-table-column label='创建时间' min-width='160'>
          <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
      </el-table>
      <el-table class="el-table-02" :data='tableList' style='width: 100%' @row-click="reductionRow" key='Table3' v-if="tabType == 3">
        <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
        <el-table-column prop='user_name' label='客户姓名' min-width='140'></el-table-column>
        <el-table-column prop='phone' label='联系电话' min-width='140'></el-table-column>
        <el-table-column label='减购项目' min-width='140'>
          <template slot-scope='scope'>
            <span v-text="redfieldInit(scope.row.type)"></span>
          </template>
        </el-table-column>
        <el-table-column prop='create_by' label='创建人' min-width='100'></el-table-column>
        <el-table-column label='创建时间' min-width='160'>
          <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
      </el-table>
      <el-table class="el-table-02" :data='tableList' style='width: 100%' @row-click="renewalRow" key='Table4' v-if="tabType == 4">
        <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
        <el-table-column prop='user_name' label='客户姓名' min-width='140'></el-table-column>
        <el-table-column prop='phone' label='联系电话' min-width='140'></el-table-column>
        <el-table-column label='套餐开始时间' min-width='140'>
          <template slot-scope='scope'>{{ scope.row.start_time | formatDate('yyyy-MM-dd') }}</template>
        </el-table-column>
        <el-table-column label='套餐结束始时间' min-width='140'>
          <template slot-scope='scope'>{{ scope.row.end_time | formatDate('yyyy-MM-dd') }}</template>
        </el-table-column>
        <el-table-column prop='create_by' label='创建人' min-width='100'></el-table-column>
        <el-table-column label='创建时间' min-width='160'>
          <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
      </el-table>
      <el-table class="el-table-02" :data='tableList' tooltip-effect='dark' style='width: 100%;' v-if="tabType == 5">
        <el-table-column prop='company_name' label='客户名称'></el-table-column>
        <el-table-column label='监测时间'>
          <template slot-scope='scope'>{{ scope.row.monitor_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
        <el-table-column label='监测状态'>
          <template slot-scope='scope'>{{ scope.row.monitor_state === '0' ? '正常' : '异常' }}</template>
        </el-table-column>
        <el-table-column prop='monitor_feedback' label='监测反馈'></el-table-column>
      </el-table>

      <el-table class="el-table-02" :data='tableList' tooltip-effect='dark' style='width: 100%;' v-if="tabType == 7">
        <el-table-column prop='third_party_no' label='订单号' min-width='260'></el-table-column>
        <el-table-column prop='order_status' label='订单状态' min-width='100'>
          <template slot-scope='scope'>
            <span v-if="scope.row.order_status == 0">待支付</span>
            <span v-else-if="scope.row.order_status == 1" style="color: #FF0300;">支付成功</span>
            <span v-else-if="scope.row.order_status == 2">取消订单</span>
          </template>
        </el-table-column>
        <el-table-column prop='pay_type' label='付款方式' min-width='100'>
          <template slot-scope='scope'>{{ scope.row.pay_type == 1 ? '微信' : '支付宝' }}</template>
        </el-table-column>
        <el-table-column label='付款时间' min-width='160'>
          <template slot-scope='scope'>{{ scope.row.pay_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
        <el-table-column prop='use_number' label='业务类型' min-width='120'>
          <template slot-scope='scope'>
            {{businessRemark[scope.row.business_type]}}
          </template>
        </el-table-column>
        <el-table-column prop='order_content' label='数量' min-width='100'>
          <template slot-scope='scope'>
            <span v-text="contentInit(scope.row)"></span>
            <!-- {{scope.row.order_content=='0'||!scope.row.order_content? '-' : scope.row.order_content}} -->
          </template>
        </el-table-column>
        <el-table-column prop='order_amount' label='金额' min-width='120'></el-table-column>
      </el-table>
      <el-table :data="tableList" tooltip-effect='dark' style='width: 100%;' class="el-table-02" v-if="tabType == 8">
        <el-table-column prop='company_name' label="客户名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作时间" min-width="140">
          <template slot-scope='scope'>{{ scope.row.operation_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
        </el-table-column>
        <el-table-column prop="function_name" label="埋点功能名称" min-width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phone" label="手机号码" min-width="120"></el-table-column>
        <el-table-column prop="operation_count" label="数量" min-width="90"></el-table-column>
        <el-table-column prop="operation_content" label="内容" min-width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ip" label="IP" min-width="100"></el-table-column>
      </el-table>
      <el-pagination v-if="tabType == 2 || tabType == 3 || tabType == 4 || tabType == 5 || tabType == 7 || tabType == 8" @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

      <div class="log-box" v-if="tabType == 6">
        <div class="log-item" v-for="(log, index) in logList" :key="index">
          <div class="line">
            <div class="circle"></div>
          </div>
          <div class="rihgt">
            <div class="time">{{log.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            <div class="content">{{log.content}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <customer-add v-if="dialogAdd" :customer="customerDetail"></customer-add>
    </transition>

    <div class="mask n1" v-if="dialogfeature" @click="dialogfeature = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip feature-detail-wrip" v-if="dialogfeature">
        <header>
          <span>编辑功能</span>
          <i class="iconfont icon-close" @click="dialogfeature = false"></i>
        </header>
        <div class="notice">此功能只是为了纠正重大误操作，用户一旦在前台使用该功能又遇到后台减少时，可能会导致数据丢失，所以请谨慎使用，切不可滥用。</div>
      <feature-list :featureData="featureData"></feature-list>
        <footer>
          <el-button @click="dialogfeature = false">取 消</el-button>
          <el-button type="primary" @click="savefeature">保 存</el-button>
        </footer>
      </el-container>
    </transition>

    <div class="mask n1" v-if="dialogAddDetail || dialogReductionDetail || dialogRenewalDetail" @click="dialogAddDetail = false; dialogReductionDetail = false; dialogRenewalDetail = false"></div>
    <transition name="slide">
      <additional-detail v-if="dialogAddDetail" :additional="additionalDtl"></additional-detail>
    </transition>
    <transition name="slide">
      <reduction-detail v-if="dialogReductionDetail" :reduction="reductionDtl"></reduction-detail>
    </transition>
    <transition name="slide">
      <renewal-detail v-if="dialogRenewalDetail" :renewal="renewalDtl"></renewal-detail>
    </transition>

    <div class="mask n2" v-if="dialogAdditionalAdd || dialogReductionAdd || dialogRenewalAdd" @click="dialogAdditionalAdd = false; dialogReductionAdd = false; dialogRenewalAdd = false;"></div>
    <transition name="slide">
      <additional-add v-if="dialogAdditionalAdd" :additional="additionalDtl"></additional-add>
    </transition>
    <transition name="slide">
      <reduction-add v-if="dialogReductionAdd" :reduction="reductionDtl"></reduction-add>
    </transition>
    <transition name="slide">
      <renewal-add v-if="dialogRenewalAdd" :renewal="renewalDtl"></renewal-add>
    </transition>

    <el-dialog title="转移负责人" :visible.sync="dialogTransfer" class="add-box" append-to-body>
      <div class="form-item">
        <span class="item-title">转移给</span>
        <div class="item-right">
          <el-select v-model="transferOfficer" placeholder="请选择">
            <el-option v-for="item in userList" :key="item.id" :label="item.user_name" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTransfer = false">取 消</el-button>
        <el-button type="primary" @click="transfer">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogStatus" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">{{(customerDetail.status == 0) ? '停用':'启用'}}</div>
      <div class="note" v-if="customerDetail.status == 0">停用后该客户里的所有账号将不允许登录和使用系统。</div>
      <div style="margin-top: 20px;" v-else></div>
      <div class="prompt">{{(customerDetail.status == 0) ? '你确定要停用该公司账号吗？':'你确定要启用该公司账号吗？'}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="userStatus">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后该公司所有登录账号与前台数据将会从数据库中完全移除且不可恢复。</div>
      <div class="prompt">你确定要删除该公司账号吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import formalDetailJS from '@/controller/formal-detail.js'
import featureList from '@/common/components/feature-list'// 功能清单
import customerAdd from '@/common/components/customer-add'// 新增
import additionalDetail from '@/page/business/additional-detail'// 增购详情
import additionalAdd from '@/page/business/additional-add'// 增购
import reductionDetail from '@/page/business/reduction-detail'// 减购详情
import reductionAdd from '@/page/business/reduction-add'// 减购
import renewalDetail from '@/page/business/renewal-detail'// 续费详情
import renewalAdd from '@/page/business/renewal-add'// 减购
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    featureList,
    customerAdd,
    additionalDetail,
    additionalAdd,
    reductionDetail,
    reductionAdd,
    renewalDetail,
    renewalAdd
  },
  name: 'customerDetail',
  props: ['customer'],
  data () {
    return {
    }
  },
  methods: {
    ...mapMutations({
      setPermissionData: 'PERMISSION', // 所有权限表
      setCurrentPermission: 'CURRENT_PERMISSION' // 当前模块权限
    })
  },
  mounted () {
    console.log(this.permissionData)
    console.log(this.currentPermission)
  },
  mixins: [formalDetailJS, mixin],
  computed: {
    ...mapState({
      permissionData: state => state.permission.permissionData, // 所有权限表
      currentPermission: state => state.permission.currentPermission // 当前模块权限
    })
  }
}
</script>

<style lang="scss">
.customer-detail-wrip{
  display: inline-block;
  background: #F4F5F5;
  .el-table-01{
    height: 100%;
  }
  .el-table-02{
    height: calc(100% - 60px);
    th:last-child{
      min-width: 160px;
    }
  }
}
.feature-detail-wrip{
  background: #F4F5F5;
  .notice{
    font-size: 16px;
    color: #FF7663;
    padding: 13px 36px 12px 31px;
  }
  .feature-container{
    width: calc(100% - 30px);
    height: calc(100% - 128px);
    background: #fff;
    margin: 0 auto;
    padding-bottom: 60px;
  }
  footer{
    padding: 10px 20px;
    text-align: right;
    position: absolute;
    width: 100%;
    bottom: 0;
    background: #FFFFFF;
    box-shadow: inset 0 1px 0 0 #E5E5E5;
    .el-button{
        padding: 8px 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/customer-detail.vue